import { DocPage, Section, SpecTable } from "../../components/DocChrome";

const inventory: Array<[string, string, string, string]> = [
    ["Button (+ icon API)", "Actions", "@maeiz/ui", "stable"],
    [
        "Input / Textarea / Select / MultiSelect / Combobox / SearchableDropdown",
        "Forms",
        "@maeiz/ui",
        "stable",
    ],
    [
        "TagInput / SecretField / DateField / DateRangeField / Calendar",
        "Forms",
        "@maeiz/ui",
        "stable",
    ],
    ["Checkbox / Radio / Switch / SegmentedControl", "Forms", "@maeiz/ui", "stable"],
    ["Table / Pagination", "Data", "@maeiz/ui", "stable"],
    ["Card / Section / Container / KpiCard", "Layout", "@maeiz/ui", "stable · no motion"],
    ["Badge / StatusBadge / Tag", "Status", "@maeiz/ui", "stable"],
    ["AppShell / PageHeader / BottomNav / Breadcrumb / Tabs", "Navigation", "@maeiz/ui", "stable"],
    [
        "Modal / Drawer / Tooltip / DropdownMenu / Popover / Accordion",
        "Overlays",
        "@maeiz/ui + Radix",
        "stable",
    ],
    ["Alert / Banner / Toast", "Feedback", "@maeiz/ui", "stable"],
    ["Spinner / Skeleton / EmptyState / ErrorState / Progress", "Async", "@maeiz/ui", "stable"],
    ["Avatar / Icon", "Identity", "@maeiz/ui", "stable"],
    ["tokens.css / tailwind-preset", "Foundations", "@maeiz/tokens", "stable"],
];

export function InventoryPage() {
    return (
        <DocPage
            title="Component Inventory"
            description="Canonical names — one concept, one component. Radix powers menu/popover/accordion behavior."
        >
            <Section title="Matrix">
                <div className="overflow-x-auto rounded-mz-lg border border-neutral-border dark:border-white/10">
                    <table className="min-w-full text-left text-sm">
                        <thead className="bg-neutral-light dark:bg-black/30">
                            <tr>
                                <th className="px-3 py-2">Component</th>
                                <th className="px-3 py-2">Category</th>
                                <th className="px-3 py-2">Package</th>
                                <th className="px-3 py-2">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {inventory.map(([name, cat, pkg, status]) => (
                                <tr
                                    key={name}
                                    className="border-t border-neutral-border dark:border-white/10"
                                >
                                    <td className="px-3 py-2 font-medium text-neutral-dark dark:text-white">
                                        {name}
                                    </td>
                                    <td className="px-3 py-2 text-neutral-secondary">{cat}</td>
                                    <td className="px-3 py-2 font-mono text-xs text-primary">
                                        {pkg}
                                    </td>
                                    <td className="px-3 py-2">{status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Section>
            <Section title="Naming">
                <SpecTable
                    rows={[
                        ["Button.icon", "Optional Lucide prefix — not required on every call site"],
                        ["Banner vs Alert", "Banner = full-width page; Alert = in-content"],
                        ["Combobox", "Searchable select; Select stays for simple lists"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
